import { useEffect, useRef } from 'react';
import { Label, Text } from '../../../../../styles/component.styles';

const ProductSlideshowUpdateSection = ({ onChange }) => {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!hasInitialized.current) {
      onChange({
        content: {},
        metadata: {
          padding: '2rem 0',
          margin: '2rem auto',
          background: 'transparent',
          align: 'center'
        }
      });
      hasInitialized.current = true;
    }
  }, [onChange]);

  return (
    <>
      <Label>Product Slideshow</Label>
      <Text>
        This section renders a dynamic product slideshow based on active categories and in-stock inventory.
        Styling is fixed in V1 and cannot be changed.
      </Text>
    </>
  );
};

export default ProductSlideshowUpdateSection;